<template>
    <div class="row no-wrap flex-grow">
        <q-chip
            class="chip"
            color="primary"
            text-color="white"
            icon-remove="fa-solid fa-circle-xmark"
            removable
            @remove="() => $emit('onClear')"
            data-qs="text-chip"
        >
            <div class="ellipsis" :class="{ 'font-size-small': text.length > 17 }">
                {{ text }}
            </div>
        </q-chip>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    text: string;
}>();

defineEmits<{ onClear: [] }>();
</script>
